export const ACTION_CUBIT_SNACKBAR_SHOW = 'ACTION_CUBIT_SNACKBAR_SHOW'

export const actionCubitSnackbarShow = (messages: string[], variant: 'success' | 'warning' | 'error' | 'info') => ({
    type: ACTION_CUBIT_SNACKBAR_SHOW,
    messages,
    variant,
})
